import Vue from 'vue';
import Vuex from 'vuex';
import {IAccountState } from './modules/account';
import {IAppState} from './modules/app';
// import {IRequirementState} from './modules/requirement';
import {ILabelState} from './modules/label';
// import {IUserState} from './modules/user';
// import {ISolutionState} from './modules/solution';
import {ITagsViewState} from './modules/tagsView';
// import {IPaymentState} from './modules/payment';
// import {IReqModuleState} from './modules/module';
// import {ITodoState} from './modules/todo';
import {IPermissionState} from './modules/permission';
// import {IIssueState} from './modules/issue';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  account: IAccountState;
  // requirement: IRequirementState;
  label: ILabelState;
  // user: IUserState;
  // solution: ISolutionState;
  tagsView: ITagsViewState;
  // payment: IPaymentState;
  // reqModule: IReqModuleState;
  // todo: ITodoState;
  permission: IPermissionState;
  // issue: IIssueState;
}

export default new Vuex.Store<IRootState>({});
